// User Actions
module.exports.AUTH_USER = 'AUTH_USER';
module.exports.AUTH_ERROR = 'AUTH_ERROR';
module.exports.LOGOUT_USER = 'LOGOUT_USER';
module.exports.GET_USER = 'GET_USER';
module.exports.UPDATE_USER = 'UPDATE_USER';

// Client Actions
module.exports.CREATE_CLIENT = 'CREATE_CLIENT';
module.exports.DELETE_CLIENT = 'DELETE_CLIENT';
module.exports.GET_CLIENTS = 'GET_CLIENTS';
module.exports.GET_CLIENT = 'GET_CLIENT';
module.exports.UPDATE_CLIENT = 'UPDATE_CLIENT';

// Appointment Actions
module.exports.CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
module.exports.DELETE_APPOINTMENT = 'DELETE_APPOINTMENT';
module.exports.GET_APPOINTMENTS = 'GET_APPOINTMENTS';
module.exports.UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
